// extracted by mini-css-extract-plugin
module.exports = {"parent":"leftMenu_parent__22B3D","element":"leftMenu_element__3l1aS","group":"leftMenu_group__H5mpt","groupText":"leftMenu_groupText__3kpyR"};